import { featureRoute } from '../../../../src/routes/helpers';
import { AccountPages } from '../../../../src/constants/AppConstants';

export default featureRoute('enableAutoDelayRepay', AccountPages.AUTO_DELAY_REPAY, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/account/AutoDelayRepay/index').default);
        }, 'account-auto-delay-repay');
    }
});
